// import LayoutGrid from './../Layout/LayoutGrid';

const LoadingWeatherCards = ({ elements }) => {
	const numbeOfDivs = elements;
	const placeholderDivs = [...Array(numbeOfDivs)].map((e, i) => <div key={i} className='loading loading--weather-cards'></div>);

	return placeholderDivs;
};

export default LoadingWeatherCards;
